import React from "react"
import App from "./app"
import ReactDOM from "react-dom/client";

(function (Drupal, drupalSettings, document) {
  Drupal.behaviors.bb_flechazos_header = {
    attach() {
      if (!drupalSettings.flechazosHeaderInitialized) {
        const element = document.getElementById("flechazos-app") as HTMLElement
        const root = ReactDOM.createRoot(element)
        if (root) {
          root.render(
            <React.StrictMode>
              <App />
            </React.StrictMode>,
          )
        }
        drupalSettings.flechazosHeaderInitialized = true
      }
    },
  }
})(Drupal, drupalSettings, document)
